// =============================================================================
// PROFIL FOTOGRAFLARI
// =============================================================================
//   Profil Duvari       -> resim_profil_duvari   (TEK fotograf)
//   Horizon Fotograflari -> resimler_horizon      (birden cok)
//   Cevre Fotograflari   -> resimler_cevre        (birden cok)
//
// Eski kayitlarda profil duvari "resim_horizon" adiyla tutuluyordu. Veritabani
// tasindi, ancak guncellenmemis bir saha cihazindan eski bicimde veri
// gelebilecegi icin okurken eski ad da taninir.
// =============================================================================

export const profilDuvariResmi = (d) =>
  d?.resim_profil_duvari || d?.resim_horizon || null;

export const horizonResimleri = (d) =>
  Array.isArray(d?.resimler_horizon) ? d.resimler_horizon.filter(Boolean) : [];

export const cevreResimleri = (d) =>
  Array.isArray(d?.resimler_cevre) ? d.resimler_cevre.filter(Boolean) : [];

// Formdaki veriyi yeni bicime getirir: eski "resim_horizon" -> profil duvari.
export const resimleriYeniBicimeGetir = (d) => {
  if (!d || typeof d !== "object") return d;
  const yeni = { ...d };
  if (!yeni.resim_profil_duvari && yeni.resim_horizon)
    yeni.resim_profil_duvari = yeni.resim_horizon;
  delete yeni.resim_horizon;
  if (!Array.isArray(yeni.resimler_horizon)) yeni.resimler_horizon = [];
  if (!Array.isArray(yeni.resimler_cevre)) yeni.resimler_cevre = [];
  return yeni;
};
